import { FunctionComponent, useMemo } from 'react';
import styles from '../../../styles.module.scss';
import { Tooltip } from '../../../../../Tooltip';
import { dayFormatOptions, shortMonthFormatOptions } from '../../../../../../services/dateFormats';
import { Temporal } from 'temporal-polyfill';
import { TimezoneDate } from '../../../../../TimezoneDate';
import { PublicBlockOccurrence, PublicChildOccurrence } from '@cademy-package/sdk-component-types';

type OccurrenceBlockDatesProps = {
    childOccurrences: Array<PublicChildOccurrence>;
    occurrence: PublicBlockOccurrence;
};
export const OccurrenceBlockDates: FunctionComponent<OccurrenceBlockDatesProps> = ({
    childOccurrences,
    occurrence,
}) => {
    const startDate = useMemo(
        () => Temporal.ZonedDateTime.from(occurrence.times.start.zoned_datetime),
        [occurrence]
    );
    const endDate = useMemo(
        () => Temporal.ZonedDateTime.from(occurrence.times.end.zoned_datetime),
        [occurrence]
    );

    const timezone = useMemo(() => {
        return startDate.timeZoneId;
    }, [startDate]);

    const dates = useMemo(() => {
        return {
            startMonth: <TimezoneDate date={startDate} format={shortMonthFormatOptions} />,
            startDay: <TimezoneDate date={startDate} format={dayFormatOptions} />,
            endMonth: <TimezoneDate date={endDate} format={shortMonthFormatOptions} />,
            endDay: <TimezoneDate date={endDate} format={dayFormatOptions} />,
        };
    }, [endDate, startDate]);

    return (
        <Tooltip tooltip={timezone}>
            <div className={styles.dateText} role="textbox" aria-label="Single day text">
                <span>
                    {dates.startDay}&nbsp;
                    {dates.startMonth}
                </span>
                <span aria-hidden="true"> → </span>
                <span className="screen_reader_hidden"> to </span>
                <span>
                    {dates.endDay}&nbsp;{dates.endMonth}
                </span>
                <span> ({childOccurrences.length} sessions)</span>
            </div>
        </Tooltip>
    );
};
